import { publicPath } from '../utils/canonicalUrl';

/** Articoli per pagina in /blog/ — tenere allineato a scripts/run-react-snap.js */
export const BLOG_PER_PAGE = 18;

export function blogListingPath(page) {
  const n = Number(page);
  if (!Number.isFinite(n) || n <= 1) return publicPath('/blog');
  return publicPath(`/blog/page/${n}`);
}

export function blogListingCanonicalPath(page) {
  const n = Number(page);
  if (!Number.isFinite(n) || n <= 1) return '/blog';
  return `/blog/page/${n}`;
}
